(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  function init() {
    document.querySelectorAll('[data-cchef-accordion]').forEach(setupAccordionGroup);
  }

  function setupAccordionGroup(group) {
    group.querySelectorAll('[data-accordion-item]').forEach(function (item) {
      var q = item.querySelector('[data-accordion-toggle]');
      if (!q) return;
      var openByDefault = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', openByDefault ? 'true' : 'false');
      q.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        if (group.hasAttribute('data-accordion-exclusive')) {
          group.querySelectorAll('[data-accordion-item]').forEach(function (other) {
            other.setAttribute('data-open', 'false');
          });
        }
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
      });
    });
  }
})();
